import React from "react";

const RadioButtonsResident = ({ name, register }) => {
  return (
    <div className="clientForm__control__radioButton">
      <div className="clientForm__control__radioButton__item">
        <input
          type="radio"
          name={name}
          id={"yes_"+name}
          value="1"
          ref={register}
        />
        <label htmlFor={"yes_"+name} />
        <span>Sí</span>
      </div>
      <div className="clientForm__control__radioButton__item">
        <input
          type="radio"
          name={name}
          id={"no_" + name}
          value="0"
          ref={register}
        />
        <label htmlFor={"no_" + name} />
        <span>No</span>
      </div>
    </div>
  );
};

export default RadioButtonsResident;